import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  UrlTree,
} from '@angular/router';
import { Observable, map, take } from 'rxjs';
import { PermissionResource } from '../constants/permissions.constants';
import { PermissionService } from '../services/permission.service';

@Injectable({ providedIn: 'root' })
export class PermissionGuard implements CanActivate, CanActivateChild {
  constructor(
    private readonly permissionService: PermissionService,
    private readonly router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return this.checkRoute(route);
  }

  canActivateChild(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return this.checkRoute(route);
  }

  private checkRoute(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const permissionResource = route.data?.['permissionResource'] as PermissionResource | undefined;
    const permissionResources = route.data?.['permissionResources'] as PermissionResource[] | undefined;
    const requiredPermissions = route.data?.['requiredPermissions'] as string[] | undefined;

    const allowed$ = requiredPermissions?.length
      ? this.permissionService.hasAnyPermission$(requiredPermissions)
      : permissionResources?.length
        ? this.permissionService.getCurrentPermissions$().pipe(
            map((permissions) =>
              permissionResources.every((resource) =>
                this.permissionService.canReadResource(resource, permissions),
              ),
            ),
          )
      : permissionResource
        ? this.permissionService.canRead$(permissionResource)
        : this.permissionService.hasAnyPermission$([]);

    return allowed$.pipe(
      map((allowed) => (allowed ? true : this.router.createUrlTree(['/access-restricted']))),
      take(1),
    );
  }
}